import { captureException as sentryCaptureException } from '@sentry/browser';

function captureException(error) {
    sentryCaptureException(error);
}

export default captureException;
